import styled from 'styled-components'
import { breakpoints } from 'src/utils/styles/global-styles'

export const LogoContainer = styled.div`
  opacity: 0.2;
  display: inline-block;
  margin: auto;
  cursor: pointer;
  @media (max-width: ${breakpoints.m}px) {
    opacity: 1;
  }
`
export const SliderContainer = styled.div`
  background-color: ${(props) => props.theme.lavender};
  position: relative;
  z-index: 10;
  margin: 42px 0px;
  text-align: center;
  .slick-slide {
    max-width: 170px;
    justify-content: center;
  }
  .slick-current .imgContainer {
    opacity: 1;
  }
  .slick-slide .text {
    display: none;
    position: absolute;
    top: 0px;
    left: 0;
    right: 0;
    margin: auto;
    font-size: 32px;
    line-height: 40px;
    text-align: left;
  }
  slick-slider .slick-track {
    display: flex;
    align-items: center;
    justify-content: center;
    margin: auto;
    max-width: 900px;
  }
  .slick-current .text {
    display: block;
  }
  #yahoo {
    width: 160px;
  }
  #wallStreet {
    width: 86px;
    margin: auto;
  }
  #buzzfeed {
    width: 200px;
  }
  #bump {
    width: 225px;
  }
  #truetrae {
    width: 295px;
  }
  #motherly {
    width: 125px;
  }
  #lifesavvy {
    width: 260px;
  }
  @media (max-width: ${breakpoints.m}px) {
    padding: 0px 0px 40px;
    margin: 24px 0px;
    .slick-slide {
      margin: auto;
      max-width: 100%;
    }
    .slick-slider {
      padding-bottom: 0px;
    }
    .slick-slider .slick-track {
      display: block;
      max-width: none;
    }
    .slick-slide .text {
      display: block;
      position: relative;
      font-size: 20px;
      line-height: 32px;
      padding: 0px;
    }
    .slick-current .text {
      display: block;
    }
    .slick-current .imgContainer {
      opacity: 1;
    }
    .slick-dots {
      text-align: left;
    }
  }
  @media (max-width: ${breakpoints.s}px) {
    padding: 0px 0px 0px;
    .slick-slide .text {
      font-size: 24px;
      line-height: 32px;
    }
    #bump {
      width: 160px;
    }
    #truetrae {
      width: 210px;
    }
    #motherly {
      width: 90px;
    }
    #lifesavvy {
      width: 180px;
    }
  }
`
export const Card = styled.div`
  position: relative;
  padding-top: 100px;
  padding-bottom: 0px;
  display: inline-block;
  text-align: center;
  width: 100%;
  @media (max-width: ${breakpoints.xl}px) {
    padding-top: 124px;
  }
  @media (max-width: ${breakpoints.m}px) {
    padding-top: 0px;
    margin: 16px 0px 0px;
    text-align: left;
  }
`
export const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
`
export const Slide = styled.div`
  background-color: ${(props) => props.theme.lavender};
`
